module.exports = __webpack_public_path__ + "static/media/chevron-closed.0d636106.svg";